'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadataCoordinates = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getMetadataCoordinates = exports.getMetadataCoordinates = function getMetadataCoordinates(sdmxJson) {
  var dimensions = R.pathOr([], ['data', 'structure', 'dimensions', 'observation'], sdmxJson);
  var annotations = R.pathOr([], ['data', 'structure', 'annotations'], sdmxJson);
  var metadataAvailKeys = R.pipe(R.pathOr([], ['data', 'dataSets', 0, 'dimensionGroupAttributes']), R.map(function (indexes) {
    return R.props(indexes, annotations);
  }), R.filter(R.find(function (a) {
    return a && R.propEq('type', 'HAS_METADATA', a);
  })), R.keys)(sdmxJson);

  return R.map(function (key) {
    var indexes = R.split(':', key);
    return R.addIndex(R.reduce)(function (acc, vIndex, dimIndex) {
      if (R.isNil(vIndex) || R.isEmpty(vIndex)) {
        return acc;
      }
      var dim = R.nth(dimIndex, dimensions);
      if (R.isNil(dim)) {
        return acc;
      }
      var val = R.path(['values', Number(vIndex)], dim);
      if (R.isNil(val)) {
        return acc;
      }
      return R.assoc(dim.id, val.id, acc);
    }, {}, indexes);
  }, metadataAvailKeys);
};